import { createSlice } from "@reduxjs/toolkit";

const timerslice=createSlice({
  name:"timerslice",
  initialState:{sec:0},
  reducers:{
    setSec(state,action) {
      state.sec = action.payload;
    },
    setIncrementSec(state) {
      state.sec += 1
    }
  }
});

export const { setSec, setIncrementSec }=timerslice.actions
export default timerslice.reducer